import z from 'zod';
import { std } from './js';

export async function chunkedDbTransaction<T, R>(
    items: T[],
    chunkSize: number,
    insertFunction: (batch: T[]) => Promise<R[]>,
): Promise<R[]> {
    const results = await Promise.all(std.Array.chunk(items, chunkSize).map(insertFunction));

    return results.flat();
}

export type Pagination_Args = Pagination_Args.Page | Pagination_Args.Offset;
export namespace Pagination_Args {
    export const PAGE_VALIDATOR = z.object({
        /** 0-based page index */
        pageIdx: z.int().min(0),
        /** Page size */
        size: z.int().min(0),
    });
    export type Page = z.output<typeof PAGE_VALIDATOR>;

    export const OFFSET_VALIDATOR = z.object({
        /** 0-based offset */
        offset: z.int().min(0),
        /** How many items to take */
        limit: z.int().min(0),
    });
    export type Offset = z.output<typeof OFFSET_VALIDATOR>;

    export function getOffset(pagination: Pagination_Args): number {
        if ('offset' in pagination) return pagination.offset;

        return pagination.pageIdx * pagination.size;
    }

    export function getSize(pagination: Pagination_Args): number {
        if ('offset' in pagination) return pagination.limit;

        return pagination.size;
    }

    /** NOTE: could return a float if `pagination.offset % pagination.limit > 0` */
    export function getPageIdx(pagination: Pagination_Args): number {
        if ('pageIdx' in pagination) return pagination.pageIdx;

        return pagination.offset / pagination.limit;
    }
}
